
















import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'

@Component({
  components: {}
})
export default class TestingPointDes extends ViewBase {
  @Prop({ default: null }) steps!: any
  @Prop({ default: null }) points!: any
  @Prop({ default: '' }) parent!: string
  @Prop({ default: 0 }) time!: number
  lang: any = {}

  columns: any = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  setColumns() {
    this.columns = [
      {
        title: this.lang.step,
        dataIndex: 's_number'
        //   scopedSlots: { customRender: 'name' }
      },
      {
        title: this.lang.description,
        className: 'column-money',
        dataIndex: 's_desc'
      },
      {
        title: this.lang.includingTest,
        dataIndex: 'points_ids'
      }
    ]
  }

  created() {
    this.lang = this.i18n.vStudy
    this.setColumns()
  }
  @Watch('time')
  watchTime() {
    this.setColumns()
  }
}
